import { useState, useRef, useCallback } from "react";

import {
  Popover,
  PopoverContent,
  PopoverAnchor,
} from "@bigbinary/neeto-atoms/primitives";
import { globalProps } from "neetocommons/initializers";
import { useTranslation } from "react-i18next";
import CopyToClipboardButton from "v2/components/CopyToClipboardButton";

import MenuItemButton from "./MenuButton";

import { MY_ORGANIZATION_URL } from "../../constants";

const WorkspaceMenu = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const timeoutRef = useRef(null);

  const handleMouseEnter = useCallback(() => {
    clearTimeout(timeoutRef.current);
    setOpen(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    timeoutRef.current = setTimeout(() => setOpen(false), 150);
  }, []);

  return (
    <Popover {...{ open }} onOpenChange={setOpen}>
      <PopoverAnchor asChild>
        <MenuItemButton
          onClick={() => setOpen(prev => !prev)}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      </PopoverAnchor>
      <PopoverContent
        align="center"
        className="z-[99999] w-56 gap-0.5 p-1"
        side="right"
        sideOffset={8}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <a
          className="hover:bg-accent flex h-9 w-full items-center gap-2 rounded-md px-2.5 text-sm font-medium"
          data-testid="profile-organization-settings-button"
          href={MY_ORGANIZATION_URL}
          rel="noreferrer"
          target="_blank"
        >
          {t("neetoMolecules.sidebar.workspaceMenu.settings")}
        </a>
        {globalProps.organization?.subdomain && (
          <div className="px-3 py-2">
            <span className="flex flex-col gap-0.5 text-start">
              <span className="text-sm font-medium">
                {t("neetoMolecules.sidebar.workspaceMenu.subdomain")}
              </span>
              <span className="text-muted-foreground flex items-center gap-1 text-xs">
                <span className="min-w-0 truncate">
                  {globalProps.organization.subdomain}
                </span>
                <CopyToClipboardButton
                  className="flex-shrink-0"
                  value={globalProps.organization.subdomain}
                  variant="ghost"
                />
              </span>
            </span>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
};

export default WorkspaceMenu;
